const BUY_BUTTON_CLASS = 'js-product-buy-button'
const AUTH_GUARD_CLASS = 'js-fc-authguard'
const SELLING_PERIOD_CLASS = 'ruffruff-selling-periods__product-message'
const primaryLocale = 'ja'

const {
  FC_AUTH_URL,
  FC_ALLOW_REFS,
  FC_BUTTON_LABEL,
  FC_DEFAULT_LINK_PW,
  FC_LINK_PW,
} = window.fcAuthSettings

const FC_PW = FC_LINK_PW || FC_DEFAULT_LINK_PW

const { FC_SIGNIN_URLS } = fcAuthSettings

const REFERER_URLS = Object.values(FC_ALLOW_REFS).map(url => getOrigin(url))

const FC_SIGNIN_URL = getOrigin(FC_AUTH_URL) === getOrigin(FC_ALLOW_REFS.stg) ? FC_SIGNIN_URLS.stg : FC_SIGNIN_URLS.prod
// セッションストレージに設定された言語にリダイレクト
const redirectToLocale = () => {
  const sessionLocale = sessionStorage.getItem('locale')
  if ((!sessionLocale || sessionLocale === "")) return

  const { isPrimaryLocale, locale } = window.variantStrings

  if (sessionLocale === locale) return

  const { pathname, origin, search } = window.location
  const pathnames = pathname.split('/')

  if (isPrimaryLocale) {
    pathnames[1] = `${sessionLocale}/${pathnames[1]}`
  }
  else if (sessionLocale === primaryLocale) {
    pathnames.splice(1, 1)
  }
  else {
    pathnames[1] = sessionLocale
  }

  const newPathname = pathnames.join('/')

  const redirectUrl = `${origin}${newPathname}${search}`

  // セッションストレージをリセット
  sessionStorage.removeItem('locale')

  window.location.href = redirectUrl
}

// ファンクラブ経由どうかを判定する関数（参照元URLとクエリパラメータのパスワードで判定）
function isFanclubReferer() {
  // セッションストレージの認証ステータスを確認する
  const urlParams = new URLSearchParams(window.location.search)
  const password = urlParams.get('link_pw')
  const referrer = getOrigin(document.referrer)

  if (FC_PW !== '' && FC_PW !== null) {

    const sessionLinkPass = sessionStorage.getItem('fanclub_auth_pw')
    if (sessionLinkPass === FC_PW) {
      return true
    }

    // パスワードが一致し、参照元URLが指定されたURLと一致する場合
    if (REFERER_URLS.includes(referrer) && password === FC_PW) {
      // セッションストレージに認証ステータスを保存
      sessionStorage.setItem('fanclub_auth_pw', password)
      return true
    }
  
    if (REFERER_URLS.includes(sessionStorage.getItem('fanclub_auth_referrer_history')) && sessionStorage.getItem('fanclub_auth_pw_history') === FC_PW) {
      // セッションストレージに認証ステータスを保存`  
      sessionStorage.setItem('fanclub_auth_pw', sessionStorage.getItem('fanclub_auth_pw_history'))
      return true
    }
  }

  if (password && referrer && REFERER_URLS.includes(referrer)) {
    // セッションストレージに認証ステータスを保存
    sessionStorage.setItem('fanclub_auth_pw_history', password)
    sessionStorage.setItem('fanclub_auth_referrer_history', referrer)
  }

  return false
}

isFanclubReferer()

function waitForElementsByClass(className, timeout = 100) {
  const existing = document.getElementsByClassName(className)
  if (existing.length) return Promise.resolve(existing)

  return new Promise((resolve) => {
    const observer = new MutationObserver(() => {
      const found = document.getElementsByClassName(className)
      if (found.length) {
        observer.disconnect()
        resolve(found)
      }
    })

    observer.observe(document.body, { childList: true, subtree: true })

    if (timeout > 0) {
      setTimeout(() => {
        observer.disconnect()
        resolve(document.getElementsByClassName(className))
      }, timeout)
    }
  })
}

// ファンクラブ認証ガードが有効になっている商品ページの場合は、認証済みかを判定して購入ボタンをファンクラブログインページへのaタグに書き換える
async function handleFanclubAuthGuard() {
  const authGuard = document.querySelector(`.${AUTH_GUARD_CLASS}`)
  if (!authGuard) return
  redirectToLocale()

  // 認証ガードが有効な場合は、認証済みかを判定して購入ボタンをファンクラブログインページへのaタグに書き換える
  if (isFanclubReferer()) return

  // 商品が在庫切れの場合は何もしない
  console.log('check unavailable')
  if(!window.fcAuthSettings.IS_AVAILABLE) return


  // 認証が通らかなった場合は「FC認証」ボタンのaタグにする
  const buyButtons = document.getElementsByClassName(BUY_BUTTON_CLASS)
  await waitForElementsByClass(SELLING_PERIOD_CLASS)

  Array.from(buyButtons).forEach(async (buyButton) => {
    const redirectUrl = encodeURIComponent(FC_AUTH_URL)
    const { locale } = window.variantStrings

    const aTag = document.createElement('a')
    aTag.href = `${FC_SIGNIN_URL}?url=${redirectUrl}&lang=${locale}`
    aTag.className = buyButton.className
    aTag.textContent = FC_BUTTON_LABEL
    buyButton.parentNode.appendChild(aTag)
    buyButton.attributes.disabled = true
    buyButton.style.display = 'none'
    // await waitForElementsByClass(SELLING_PERIOD_CLASS)
    // buyButton.remove()

    aTag.onclick = (e) => {
      sessionStorage.setItem('locale', locale)
    }

  })
}

handleFanclubAuthGuard()


function getOrigin(url) {
  try {
    return new URL(url).origin
  } catch (e) {
    console.error('Invalid URL:', url)
    return ''
  }
}

